export default function RightArrowOutline({
    style,
}){
    return  <svg style={style} width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.2656 0.953125L17.2656 5.85109L12.2656 10.749" stroke="#215DAA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16.7656 6.05469H0.765625" stroke="#215DAA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
}
